export const routeNumber = (routeName: string | null | undefined): string => {
	if (!routeName) {
		return '—'
	}
	const match = routeName.match(/№\s*([^\s(]+)/)
	return match ? match[1] : routeName.split(/[\s(]/)[0]
}
